window.app.factory("apiCall", [
  "$http",
  "backend.config",
  function($http, backend) {
    return function apiCall(cfg) {
      const {
        endpoint,
        resObj,
        method = "GET",
        placeholders = true,
        unwrap = true,
        ...otherCfg
      } = cfg;
      const path = placeholders
        ? endpoint
            .replace("$", backend.enterprise.code)
            .replace("@", backend.userdata.email)
        : endpoint;

      const config = {
        url: fixPath(API_URL + path),
        method,
        ...otherCfg
      };

      console.log("apiCall req", { endpoint, config });

      return $http(config).then(function(res) {
        console.log("apiCall res", { res });
        if (resObj) resObj.inject(res.data);
        return unwrap ? res.data : res;
      });
    };

    function fixPath(url) {
      return url.replace(/(https?:\/\/[^/]+)\/+/, "$1/");
    }
  }
]);



// WEBPACK FOOTER //
// ./src/services/apiCall.js